import React, { useEffect, useState, useImperativeHandle } from "react";
import braintreeGivingFormApi from "../../../shared/api/giving-form-api/braintreeGivingFormApi";
import braintree from "braintree-web-drop-in";

const Braintree = ({ braintreeDropin }) => {
  return <div id="dropin-container"></div>;
};

export default Braintree;
